/**
 * @file location-page
 * @author
 */

import React, {useState} from 'react';
import {Popover} from 'antd';
import {recordProxy} from '../../../util';
import CustomButton from '../../CustomButton/index';
import iconScan from '../../../pages/normalLandPage/imgs/icon-scan.svg';

import {ICompQrcodeProps as IProps} from '../locationResInterface';

export default function CompQrcode(props: IProps) {
    const [visible, setVisible] = useState(false);
    const handleVisibleChange = visible => {
        if (!visible) {
            const {search, pageType, srcid, pageTitle, pageTag} = props;
            const pointParam = {
                search,
                pageType,
                srcid,
                pageTitle,
                pageTag
            };
            recordProxy('locationScanShow', 'show', JSON.stringify(pointParam));
        }
        setVisible(visible);
    };
    const qrCodeUrl = (
        window.location.host.indexOf(':8066') > -1
        || window.location.host.indexOf('safe-mobsec06.bcc-bdbl.baidu.com') > -1)
        ? 'http://safe-mobsec06.bcc-bdbl.baidu.com:8879' : 'https://mhaoma.baidu.com';
    /* eslint-disable */
    const qrCode = <img className='qr-code' src={window.location.origin
        + '/api/v1/qr_code?url='
        + encodeURIComponent(
            `${qrCodeUrl}/pages/search-result/search-result?search=${props.search}&scan=true`
        )}></img>
    return (<div>
        <Popover
            content={qrCode}
            trigger="hover"
            open={visible}
            onOpenChange={handleVisibleChange}
            placement="bottom"
            overlayClassName={'comp-custom-popover-class'}
        >
            <CustomButton className="scan-btn" type="primary">
                <img src={iconScan} className="icon-scan"></img>
                扫码拨号
            </CustomButton>
        </Popover>
    </div>);
}